import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import useMmcService from "../../services/MmcService";
import InitContext from "../pages/InitContext";
import {Consts} from "../pages/consts";

const SymptomImages = ({
  symptom,
  onDeleteImage,
  onAddImages,
  printView = false
}) => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [thumbnailUrls, setThumbnailUrls] = useState({});
  const context = useContext(InitContext);
  const { getDbSymptomImage } = useMmcService();

  const loadThumbnailUrls = async () => {
    const urls = {};

    if (symptom?.images) {
      //const images = await getDbSymptomImages(context?.token, symptom?.id);
      for (const image of symptom?.images) {
        urls[image?.id] = await getThumbnailUrl(image?.id);
      }
    }

    setThumbnailUrls(urls);
  };

  useEffect(() => {
    loadThumbnailUrls().then();
  }, [symptom?.images]);

  const handleThumbnailClick = async (imageId) => {
    const result = await getDbSymptomImage(context?.token, imageId?.id);

    if (result) {
      const { blob } = result;
      const url = window.URL.createObjectURL(blob);
      setSelectedImage(url);
    }
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const getThumbnailUrl = async (imageId) => {
    const result = await getDbSymptomImage(context?.token, imageId);

    if (result) {
      const { blob } = result;
      return window.URL.createObjectURL(blob);
    }
  };

  const handleAddImages = (event) => {
    const newFiles = Array.from(event.target.files);
    onAddImages(symptom, newFiles);
  };

  const uploadTooltip = `${t("add_related_images")} (${t("if_applicable")})`;

  return (
    <>
      <div className="w3-row w3-padding-small symptom-images-header-row">
        <label>{t("images")}</label>
        {!printView && (
          <>
            <input
              id={`symptom-images-upload-${symptom?.id}`}
              type="file"
              accept="image/*"
              multiple
              onChange={handleAddImages}
              style={{ display: Consts.NONE }}
            />
            <label
              htmlFor={`symptom-images-upload-${symptom?.id}`}
              className="symptom-ui-button symptom-ui-button--primary symptom-ui-button--icon symptom-image-upload-label"
              title={uploadTooltip}
              aria-label={uploadTooltip}
            >
              <FontAwesomeIcon icon={faPlus} />
            </label>
          </>
        )}
      </div>
      <div className="w3-row">
        <div className="w3-col s12">
          <div className="w3-row">
            {symptom?.images?.map((image, index) => (
              <div key={index} className="w3-col s2 w3-border w3-margin-left">
                {!printView && (
                  <FontAwesomeIcon
                    icon={faXmark}
                    onClick={() => onDeleteImage(symptom?.id, image?.id)}
                    className="w3-right label-link"
                  />
                )}
                <img
                  key={index}
                  src={thumbnailUrls[image?.id]}
                  alt={image?.file_name}
                  className="w3-image w3-hover-opacity thumbnail"
                  onClick={() => handleThumbnailClick(image)}
                />
              </div>
            ))}
          </div>
          {symptom?.images?.length > 0 && !printView && (
            <div className="w3-row symptom-images-help-text-row">
              <label className="w3-small">{t("click_on_thumbnail_to_enlarge")}</label>
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <div className="image-fullscreen-container" onClick={handleCloseModal}>
          <img src={selectedImage} alt="Symptom image" className="image-fullscreen" />
          {symptom?.images?.length > 0 && !printView && (
            <div className="image-fullscreen-close"><label>{t("click_to_close")}</label></div>
          )}
        </div>
      )}
    </>
  );
};

export default SymptomImages;
